import { TextField } from '@mui/material'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import React, { useEffect } from 'react'

const DobCKYC = ({ field, form, ...props }) => {

    useEffect(() => {

        console.log('s', field)
    }, [])

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <MobileDatePicker
                disableFuture
                id={field.name}
                name={field.name}
                value={field.value}
                inputFormat="MM/DD/YYYY"

                onChange={(newValue) => {
                    // let date = moment(newValue).format("MM/DD/YYYY") 
                    // let day = date.format("MM")
                    // let month = date.format("DD")
                    // let year = date.format("YYYY")
                    form.setFieldValue(field.name, moment(newValue).format("MM/DD/YYYY"))
                }}
                renderInput={(params) => {
                    //console.log('param',params)
                    return (

                        <TextField
                            //touched={form.touched}
                            name={field.name}
                            id={field.name}
                            sx={{
                                /* "& label.Mui-focused": {
                                  display: "none"
                                }, */

                                "& legend": {
                                    display: "none"
                                },
                                '& .MuiOutlinedInput-root': {

                                    "&.Mui-error fieldset ": {
                                        borderColor: "rgba(0, 0, 0, 0.23) !important"  // default
                                    },



                                },


                            }}
                            //error={Boolean(currentError)}

                            fullWidth
                            {...params} />
                    )
                }}
            />
        </LocalizationProvider>
    )
}

export default DobCKYC